module.exports = __webpack_public_path__ + "static/media/ic-event-at-home.a87ab4cc.svg";